import { makeAutoObservable } from "mobx";

export class SynkSmashLocalStore {
  instanceId: string;
  props: any = {};

  constructor(instanceId: string) {
    this.instanceId = instanceId;
    makeAutoObservable(this);
  }

  setProps(props: any) {
    this.props = props;
  }
}

export default SynkSmashLocalStore;
